<div class="card">
  <h5 class="card-header">EC2 Groups</h5>
  <div class="card-body">

    <div style="display: flex; justify-content: flex-end; align-items: center;" *ngIf="writeAccess">
      <button class="btn btn-light" style="background-color: #5864FF; color: white;"
        (click)="createEC2Group()">Create</button>
    </div>

    <table class="table table-docs table-hover">
      <thead>
        <tr>
          <th>S.N.</th>
          <th *ngFor="let h of headers">{{h.name}}</th>
          <th>Instance List </th>
          <th *ngIf="writeAccess">Update</th>
        </tr>
      </thead>

      <tbody [ngStyle]="{'display': groups.length > 0 ? 'table-row-group' : 'none'}"
        *ngFor="let i of groups; let j = index">
        <tr>
          <td>{{j+1}}</td>
          <td *ngFor="let h of headers">
            <span *ngIf="h.click" class="btn" (click)="callFunction(h.click, i)">
              <span (click)="callFunction(h.click,i)">
                {{i[h.id]}}
              </span>
            </span>
            <span *ngIf="!h.click">
              {{i[h.id]}}
            </span>
          </td>
          <td><button class="btn btn-light" (click)="showGroupInstances(i)">{{i.groupName}}</button> </td>
          <td *ngIf="writeAccess"><button class="btn btn-light" (click)="updateGroupInstances(i)"><i
                class="fa fa-pencil"></i></button> </td>
        </tr>
      </tbody>
      <tbody [ngStyle]="{'display': groups.length == 0 ? 'table-row-group' : 'none'}">
        <tr>
          <td [attr.colspan]="headers.length + 2 + (writeAccess ? 1 : 0)">
            <div style="text-align: center;">No EC2 Groups Found</div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>

<modal-popup *ngIf="showGroup" [headers]="instancesHeader" [data]="showGroup.instanceList"
  [modalTitle]="showGroup.groupName" [showModal]="true" (hideModal)="hideGroupInstances($event)"></modal-popup>

<ec2-group *ngIf="writeAccess && updateGroup" [action]="groupAction" [group]="updateGroup"
  (hideModel)="hideUpdateGroupInstances($event)"></ec2-group>